import { useEffect } from 'react';

import akasha from '../assets/icons/backOffice/Packages/akasha.png';
import baseChain from '../assets/icons/backOffice/Packages/baseChain.png';
import binance from '../assets/icons/backOffice/Packages/binance.svg';
import flipme from '../assets/icons/backOffice/Packages/flipme.png';
import metamask from '../assets/icons/backOffice/Packages/metamask.png';
import trc from '../assets/icons/backOffice/Packages/trc.svg';
import ultron from '../assets/icons/backOffice/Packages/ultron.png';

import usdt from '../assets/images/backoffice/tokens/tether.png';
import usdc from '../assets/images/backoffice/tokens/usdc.png';

import { useTranslation } from 'react-i18next';

import moment from 'moment';
import { Dispatch } from 'redux';
import { useAppSelector } from '../app/hooks';
import { ErrorToast, SuccessToast } from '../components/common/Toasts/Toasts';
import {
  AIRDROPS,
  AKASHA,
  DASHBOARD,
  DEX_NET,
  EARNINGS,
  ENTRY_PACKAGE,
  KRIPTO_TAP,
  MY_HUBS,
  MY_TEAM,
  ORDERS
} from '../routes/routes';
import {
  IconAirDrops,
  IconAkasha,
  IconBigWhale,
  IconDexNet,
  IconDiscountCode,
  IconEarnBet,
  IconEarnings,
  IconGuardianNodes,
  IconHelpdesk,
  IconHome,
  IconKriptoTap,
  IconMontly,
  IconMyHubs,
  IconMyPackage,
  IconMyTeam,
  IconOrders,
  IconPaymentHubs,
  IconRanking,
  IconResources,
  IconTradingHubs,
  IconTravelPackages
} from '../styles/Icons';
import { UserTypes } from '../types/loginTypes';
import {
  NetworkType,
  TokensType,
  WalletNFTType,
  WalletsNFTType,
  WalletsType
} from '../types/types';
import { EarnBetResponse } from '../views/Earnings/Withdraw/Withdraw.types';
import { UserEventTicketModel } from '../views/EventPromo/Event.types';
import {
  MyOrderListModel,
  Subscription,
  UserPackageModel
} from '../views/Marketplace/Maeketplace.types';
import { UserVirtualOfficeLicence } from '../views/Settings/settings.types';
import { store } from './localstorage-helper';

export const validateEmail = (mail: string) => {
  var validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (mail.match(validRegex)) {
    return true;
  } else {
    return false;
  }
};

export const UploadKycImagesProgressStyles = {
  // Customize the root svg element
  root: {},
  // Customize the path, i.e. the "completed progress"
  path: {
    // Path color
    stroke: `rgba(255, 255, 255)`,
    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
    strokeLinecap: 'round',
    // Customize transition animation
    transition: 'stroke-dashoffset 0.5s ease 0s',
    // Rotate the path
    // transform: 'rotate(0.25turn)',
    transformOrigin: 'center center'
  },
  // Customize the circle behind the path, i.e. the "total progress"
  trail: {
    // Trail color
    stroke: 'none',
    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
    strokeLinecap: 'butt',
    // Rotate the trail
    transform: 'rotate(0.25turn)',
    transformOrigin: 'center center'
  },
  // Customize the text
  text: {
    // Text color
    fill: '#fff',
    // Text size
    fontSize: '30px',
    fontWeight: '500'
  },
  // Customize background - only used when the `background` prop is true
  background: {
    fill: 'none'
  }
};

export const videoConstraints = {
  facingMode: 'environment'
};

export const videoConstraintsSelfie = {
  facingMode: 'user',
  aspectRatio: { exact: 1 }
};

export const convertImage = async (image: any, imageName: string) => {
  const response = await image;

  const blob = await fetch(response).then((res) => res.blob());

  const file = new File([blob], imageName, { type: 'image/jpeg' });

  return file;
};

export function useOnClickOutside(ref: any, handler: (event: any) => void) {
  useEffect(
    () => {
      const listener = (event: any) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return () => {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

export const NumberRound = (num: number) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const SidebarNavLinks = () => {
  const { t } = useTranslation('layout');
  const {
    // isCanadaRestrictedUser,
    // canBuyBigWhale,
    // canBuyTravelPackages,
    // canBuyFlipMePackages,
    // canBuyStakingPackages,
    // isJapanRestrictedUser,
    canBuyAkashaPackages,
    userType
  } = useAppSelector((state) => state.auth.userInfo);

  const links = [
    {
      name: t('nav_items.home'),
      link: DASHBOARD,
      disabled: false
    },
    {
      name: t('nav_items.my_team'),
      link: MY_TEAM,
      disabled: false
    },
    {
      name: t('nav_items.earnings'),
      link: EARNINGS,
      disabled: false
    },

    // {
    //   name: 'BigWhale',
    //   link: BIG_WHALE,
    //   disabled: false,
    //   hidden: isCanadaRestrictedUser || !canBuyBigWhale
    // },
    {
      name: 'Entry Packages',
      link: ENTRY_PACKAGE,
      disabled: false
    },
    {
      name: 'AirDrops',
      link: AIRDROPS,
      disabled: false
    },

    {
      name: 'Guardian Nodes',
      link: AKASHA,
      disabled: false,
      hidden: !canBuyAkashaPackages
    },

    {
      name: 'KryptoTap',
      link: KRIPTO_TAP,
      disabled: false
    },

    // {
    //   name: 'Starter Packages',
    //   link: STARTER,
    //   disabled: false
    // },
    // {
    //   name: 'EarnBet',
    //   link: EARN_BET,
    //   disabled: false
    //   // hidden: !canBuyAkashaPackages
    // },

    // {
    //   name: 'FlipMe',
    //   link: FLIPME_CARDS,
    //   disabled: false,
    //   hidden: !canBuyFlipMePackages
    // },

    // {
    //   name: 'Travel',
    //   link: TRAVEL_PACKAGES,
    //   disabled: false,
    //   hidden: !canBuyTravelPackages
    // },

    // {
    //   name: t('nav_items.trading'),
    //   link: TRADING,
    //   disabled: false,
    //   hidden: true
    // },

    // {
    //   name: t('nav_items.payment'),
    //   link: PAYMENT,
    //   disabled: false,
    //   hidden: isCanadaRestrictedUser || !isJapanRestrictedUser
    // },
    // {
    //   name: t('nav_items.staking_hubs'),
    //   link: MARKETPLACE,
    //   disabled: false,
    //   hidden: !canBuyStakingPackages
    // },
    {
      name: t('nav_items.my_hubs'),
      link: MY_HUBS,
      disabled: false
    },
    {
      name: t('nav_items.orders'),
      link: ORDERS,
      disabled: false
    }

    // {
    //   name: t('nav_items.ranking'),
    //   link: RANKING,
    //   disabled: false
    // },

    // {
    //   name: t('nav_items.resources'),
    //   link: RESOURCES,
    //   disabled: false,
    //   hidden: isCanadaRestrictedUser
    // }
  ];

  // return userType === UserTypes.Regular ? links : links.slice(3, 8);
  return [
    {
      name: t('nav_items.home'),
      link: DASHBOARD,
      disabled: false,
      hidden: false
    }
  ];
};

export const SidebarIcon = ({ link }: { link: string }) => {
  const { t } = useTranslation('layout');
  switch (link) {
    case t('nav_items.home'):
      return <IconHome />;

    case t('nav_items.my_team'):
      return <IconMyTeam />;

    case t('nav_items.earnings'):
      return <IconEarnings />;

    case t('nav_items.trading'):
      return <IconTradingHubs />;

    case 'AirDrops':
      return <IconAirDrops />;

    case 'KryptoTap':
      return <IconKriptoTap />;

    case 'Dex Net':
      return <IconDexNet />;

    case 'Entry Packages':
      return <IconDexNet />;

    case 'Guardian Nodes':
      return <IconGuardianNodes />;

    case 'Starter Packages':
      return <IconAkasha />;

    case 'EarnBet':
      return <IconEarnBet />;

    case 'FlipMe':
      return <IconPaymentHubs />;

    case 'Travel':
      return <IconTravelPackages />;

    case 'BigWhale':
      return <IconBigWhale />;

    case t('nav_items.discount_code'):
      return <IconDiscountCode />;

    case t('nav_items.payment'):
      return <IconPaymentHubs />;

    case t('nav_items.staking_hubs'):
      return <IconMyHubs />;

    case t('nav_items.my_hubs'):
      return <IconMyPackage />;

    case t('nav_items.orders'):
      return <IconOrders />;

    case t('nav_items.montly'):
      return <IconMontly />;

    case t('nav_items.ranking'):
      return <IconRanking />;

    case t('nav_items.resources'):
      return <IconResources />;

    case t('profile.helpdesk'):
      return <IconHelpdesk />;

    default:
      return null;
  }
};

export const progressCircleStyles = {
  // Customize the root svg element
  root: {},
  // Customize the path, i.e. the "completed progress"
  path: {
    // Path color
    stroke: `
    #fefefe
    `,
    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
    // strokeLinecap: 'butt',
    // Customize transition animation
    transition: 'stroke-dashoffset 0.5s ease 0s',
    // Rotate the path
    // transform: 'rotate(0.25turn)',
    transformOrigin: 'center center'
  },
  // Customize the circle behind the path, i.e. the "total progress"
  trail: {
    // Trail color
    stroke: '#353130',
    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
    // strokeLinecap: 'butt',
    // Rotate the trail
    // transform: 'rotate(0.25turn)',
    transformOrigin: 'center center',
    border: '2px solid rgba(28, 23, 22, 0.3)'
  },
  // Customize the text
  text: {
    // Text color
    fill: '#FEFEFE',
    // Text size
    color: '#FEFEFE',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: ' 24px'
  },
  // Customize background - only used when the `background` prop is true
  background: {
    fill: '#3e98c7'
  }
};

export const abbreviateNumber = (value: any) => {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ['', 'k', 'm', 'b', 't'];
    var suffixNum = Math.floor(('' + value).length / 3);
    var shortValue;
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum !== 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue && shortValue % 1 !== 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
};

export const NameInitials = () => {
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const name =
    userInfo?.user?.name?.charAt(0) + userInfo?.user?.surname?.charAt(0);
  return name;
};

export const SomeUserNameInitials = (name: string, surname: string) => {
  const nameSurname = name?.charAt(0) + surname?.charAt(0);
  return nameSurname;
};

export const GoToMyTeam = (history: any, tab: string) => {
  const SELECTED_TAB_LC_KEY = 'MY_TEAM_SELECTED_TAB_LC_KEY';
  store(SELECTED_TAB_LC_KEY, tab);
  history.push(MY_TEAM);
};

export const formatterCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  unitDisplay: 'short'
  // These options are needed to round to whole numbers if that's what you want.
  // minimumFractionDigits: 7 // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const formatUSD = (v: number = 0) => {
  const value = v === null || v === undefined ? 0 : v;

  const isWholeNumber = Number.isInteger(value);

  if (isWholeNumber) {
    const comma =
      value && value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${comma},00`;
  } else {
    let parsedNumber = value?.toFixed(2);

    let convertedNumber = parsedNumber?.toString();

    let num = convertedNumber?.split('.');

    let splitedNumber = convertedNumber && num[1];

    convertedNumber = convertedNumber?.replace('.', ',');

    convertedNumber = convertedNumber
      ?.toString()
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (splitedNumber?.length === 1) {
      return `${convertedNumber}0`;
    } else {
      return convertedNumber;
    }
  }
};

export const formatUSD2 = (value: number = 0) => {
  const isWholeNumber = Number.isInteger(value);

  if (isWholeNumber) {
    const comma =
      value && value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${comma},00`;
  } else {
    let parsedNumber = value?.toFixed(4);

    let convertedNumber = parsedNumber?.toString();

    let num = convertedNumber?.split('.');

    let splitedNumber = convertedNumber && num[1];

    convertedNumber = convertedNumber?.replace('.', ',');

    convertedNumber = convertedNumber
      ?.toString()
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (splitedNumber?.length === 1) {
      return `${convertedNumber}0`;
    } else {
      return convertedNumber;
    }
  }
};

export const formatUSDNoDecimals = (value: number) => {
  const isWholeNumber = Number.isInteger(value);

  if (isWholeNumber) {
    const comma =
      value && value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${comma}`;
  } else {
    let parsedNumber = value?.toFixed(2);

    let convertedNumber = parsedNumber?.toString();

    let num = convertedNumber?.split('.');

    let splitedNumber = convertedNumber && num[1];

    convertedNumber = convertedNumber?.replace('.', ',');

    convertedNumber = convertedNumber
      ?.toString()
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (splitedNumber?.length === 1) {
      return `${convertedNumber}0`;
    } else {
      return convertedNumber;
    }
  }
};

export const formatDecimalNumber = (input: number) => {
  // Convert input to a string if it's not already
  const inputString = typeof input === 'number' ? input.toFixed(8) : input;

  // Split the string into integer and decimal parts
  const [integerPart, decimalPart] = inputString.split('.');

  // Truncate decimal part to 4 places
  const truncatedDecimalPart = decimalPart ? decimalPart.slice(0, 4) : '';

  // Join the parts with a comma
  const formattedValue = `${integerPart},${truncatedDecimalPart}`;

  return formattedValue;
};

export const formatVP = (value: number = 0) => {
  let convertedNumber = value?.toString();

  if (convertedNumber?.includes('.')) {
    let num = convertedNumber?.split('.');
    let splitedNumber = convertedNumber && num[1];

    if (splitedNumber?.length === 1) {
      convertedNumber = convertedNumber
        ?.toString()
        ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return `${convertedNumber}0`;
    } else {
      convertedNumber = convertedNumber
        ?.toString()
        ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return convertedNumber;
    }
  } else {
    convertedNumber = convertedNumber
      ?.toString()
      ?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return convertedNumber;
  }
};

export const parseFormattedInput = (value: string): number => {
  // Remove all dots (thousand separators), replace comma with dot (for decimal)
  const cleaned = value.replace(/\./g, '').replace(',', '.');

  const number = parseFloat(cleaned);
  return isNaN(number) ? 0 : number;
};

// export const formatMembers = (value) => {
//   return value?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.');
// };

export const USDT = 'USDT';
export const USDT_USDC = 'USDT/USDC';
export const CLUB = 'CLUB USDT';
export const CP = 'CP';
export const RP = 'RP';
export const ULX = 'wULX';
export const LP = 'LP';
export const MIX = 'MIX';
export const MLP = 'MLP';
export const USDC = 'USDC';

export const calculatePercentage = (
  current: number,
  required: number
): number => {
  const data = (100 * current) / required;
  return Number(data.toFixed(0));
};

const pow = Math.pow;

// The easing function that makes the scroll decelerate over time
function easeOutQuart(x: number) {
  return 1 - pow(1 - x, 4);
}

export function animateScroll({
  targetPosition,
  initialPosition,
  duration
}: {
  targetPosition: number;
  initialPosition: number;
  duration: number;
}) {
  let start: number;
  let position;
  let animationFrame: number;

  const requestAnimationFrame = window.requestAnimationFrame;
  const cancelAnimationFrame = window.cancelAnimationFrame;

  // maximum amount of pixels we can scroll
  const maxAvailableScroll =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;

  const amountOfPixelsToScroll = initialPosition - targetPosition;

  function step(timestamp: number) {
    if (start === undefined) {
      start = timestamp;
    }

    const elapsed = timestamp - start;

    // this just gives us a number between 0 (start) and 1 (end)
    const relativeProgress = elapsed / duration;

    // ease out that number
    const easedProgress = easeOutQuart(relativeProgress);

    // calculate new position for every thick of the requesAnimationFrame
    position =
      initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);

    // set the scrollbar position
    window.scrollTo(0, position);

    // Stop when max scroll is reached
    if (
      initialPosition !== maxAvailableScroll &&
      window.scrollY === maxAvailableScroll
    ) {
      cancelAnimationFrame(animationFrame);
      return;
    }

    // repeat until the end is reached
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    }
  }

  animationFrame = requestAnimationFrame(step);
}

const logError = () =>
  console.error(
    `Invalid element, are you sure you've provided element id or react ref?`
  );

const getElementPosition = (element: HTMLElement) => element.offsetTop;

export const scrollTo = ({
  id,
  duration = 3000
}: {
  id: number;
  duration: number;
}) => {
  // the position of the scroll bar before the user clicks the button
  const initialPosition = window.scrollY;

  // if the reference is id
  if (id) {
    const element = document.getElementById(id.toString());

    if (!element) {
      // log error if the reference passed is invalid
      logError();
      return;
    }

    animateScroll({
      // target position is the elements offsetTop
      targetPosition: getElementPosition(element),
      initialPosition,
      duration
    });
  }
};

export const showWallet = (address: string, number: number) => {
  const text1 = address?.slice(0, 4);
  const text2 = address?.slice(number);

  return `${text1 + '...' + text2}`;
};

export const BP = 'BP';
export const BV = 'CV';
export const UV = 'UV';
export const PO = 'PO';
export const TV = 'TV';

export const BACKOFFICE_NAME = 'Back-Office';
export const BACKOFFICE_NAME_CAPS = BACKOFFICE_NAME.toUpperCase();

export const globalPlans = () => {
  const { t } = useTranslation('settings');

  return [
    // {
    //   id: 3,
    //   title: '3-Year',
    //   price: 129,
    //   access: 3,
    //   save: 12,
    //   benefits: [
    //     {
    //       text: 'Business Volume Points (BV)'
    //     },
    //     {
    //       text: 'Full Bonuses (Team, Matching & Direct Bonus)'
    //     },
    //     {
    //       text: 'Full Access to Back-Office'
    //     }
    //   ]
    // },
    {
      id: 1,
      title: '1-Year',
      price: 49,
      access: 1,
      benefits: [
        {
          text: 'Business Volume Points (CV)'
        },
        {
          text: 'Full Bonuses (Team, Matching & Direct Bonus)'
        },
        {
          text: 'Full Access to Back-Office'
        }
      ]
    },
    {
      id: 2,
      title: '2-Year',
      title2: '+ 1-Year Free',
      price: 99,
      access: 3,
      save: 12,
      benefits: [
        {
          text: 'Business Volume Points (CV)'
        },
        {
          text: 'Full Bonuses (Team, Matching & Direct Bonus)'
        },
        {
          text: 'Full Access to Back-Office'
        }
      ]
    }
  ];
};

export const dateDifferenceInDaysFromToday = (date: string = '') => {
  const start = moment(new Date());

  const end = moment(date);

  const duration = moment.duration(end.diff(start));

  if (Number(duration.asDays().toFixed(0)) < 0) {
    return 0;
  } else {
    return Number(duration.asDays().toFixed(0));
  }
};

export const dateDifferenceInDays = (
  dateStart: string = '',
  dateEnd: string = ''
) => {
  const start = moment(dateStart);

  const end = moment(dateEnd);

  const duration = moment.duration(end.diff(start));

  if (Number(duration.asDays().toFixed(0)) < 0) {
    return 0;
  } else {
    return Number(duration.asDays().toFixed(0));
  }
};

export const getRequestConst = (unique: string) => `${unique}_REQUEST`;
export const getSuccessConst = (unique: string) => `${unique}_SUCCESS`;
export const getFailConst = (unique: string) => `${unique}_FAIL`;

export const akashaCoins: TokensType[] = [
  {
    icon: ultron,
    token: 'Ultron (ULX)',
    value: 'wulx',
    name: 'ULX',
    index: 0
  },
  {
    icon: akasha,
    token: 'Akasha (AK1111)',
    value: 'akasha',
    name: 'AK1111',
    index: 1
  }
];

export const wallets: WalletsType[] = [
  // {
  //   networkType: NetworkType.ULTRON,
  //   icon: ultron,
  //   wallet: 'Ultron Chain (ULC-20)',
  //   index: 0
  // },
  {
    networkType: NetworkType.BEP_20,
    icon: binance,
    wallet: 'Binance Smart Chain (BEP-20)',
    index: 1
  }
  // {
  //   networkType: NetworkType.TRC_20,
  //   icon: trc,
  //   wallet: 'Tron Network (TRC-20)',
  //   index: 2
  // }
];

export const akashaWallets: WalletsType[] = [
  {
    networkType: NetworkType.ULTRON,
    icon: ultron,
    wallet: 'Ultron Chain (ULC-20)',
    index: 0
  },
  {
    networkType: NetworkType.BASE_CHAIN,
    icon: baseChain,
    wallet: 'Base Chain',
    index: 1
  }
];

export const tokens: TokensType[] = [
  {
    icon: usdt,
    token: 'USDT',
    index: 0
  },
  {
    icon: usdc,
    token: 'USDC',
    index: 1
  }
];

export const walletsNFTWithdraw: WalletsNFTType[] = [
  {
    type: WalletNFTType.FLIPME,
    icon: flipme,
    wallet: 'FlipMe',
    index: 0
  },
  {
    type: WalletNFTType.METAMASK,
    icon: metamask,
    wallet: 'MetaMask',
    index: 1
  }
];

export const showNetworkType = (
  order:
    | UserPackageModel
    | UserVirtualOfficeLicence
    | UserEventTicketModel
    | MyOrderListModel
    | Subscription
    | EarnBetResponse
    | null
) => {
  switch (order?.networkType) {
    case 1:
      return wallets[0].wallet;

    default:
      return '';
  }
};

export const showTokenType = (
  order:
    | UserPackageModel
    | UserVirtualOfficeLicence
    | UserEventTicketModel
    | MyOrderListModel
    | Subscription
    | EarnBetResponse
    | null
) => {
  switch (order?.currencyType) {
    case 1:
      return tokens[0].token;
    case 7:
      return tokens[1].token;
    default:
      return '';
  }
};

export const UsersWithEmptySlots = (users: any) => {
  if (!users) return;
  const DirectUsersWithEmptySlots = [...users];
  if (users.length < 5) {
    for (let i = 0; (i = 5 - DirectUsersWithEmptySlots?.length); i++) {
      DirectUsersWithEmptySlots.push({ value: 'emptyBox' });
    }
  }
  return DirectUsersWithEmptySlots;
};

export const PLATFORM_LINK = process.env.REACT_APP_PLATFORM_LINK;

export const PERSONAL_LINK = process.env.REACT_APP_PERSONAL_LINK;

export const copyLink = (link?: string, message?: string) => {
  navigator.clipboard.writeText(link || '');
  SuccessToast(message || 'Link has been copied');
};

export function numberInRange(num: number, low: number, high: number) {
  if (num >= low && num <= high) {
    return true;
  }

  return false;
}

export const calculateNextAmount = (
  partialValue: number,
  totalValue: number
) => {
  return (partialValue / 100) * totalValue;
};

export const dateNowString = moment().format();

export const isANumber = (data: any) => {
  const numStr = new RegExp('^[0-9]+$');
  return numStr.test(data);
};

export const tryExecuteSimpleAction = async (
  dispatch: Dispatch,
  requestActionType: string,
  action: any,
  failActionType: string,
  payload: any
) => {
  try {
    dispatch({ type: requestActionType, payload });
    await action();
  } catch (error: any) {
    const status = error?.response?.status;
    const errorMessage = error?.response?.data?.error;

    if (status === 403) {
      dispatch({
        type: failActionType
      });
    } else if (status >= 400 && status < 500) {
      ErrorToast(errorMessage);
    } else if (status >= 500) {
      ErrorToast('Server error');
    }
  }
};

export const decodeJwt = (token: string) => {
  const parts = token.split('.');
  const payload = parts[1];
  const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));

  const accessToken = JSON.parse(decodedPayload);
  return accessToken.userType;
};

export const SendingTokenType = ({ network }: { network: NetworkType }) => {
  const { t } = useTranslation('marketplace');

  switch (network) {
    case NetworkType.BEP_20:
      return (
        <div>
          <b>{t('payment_method.important')}:</b> <br />
          {t('payment_method.text1')} <b>Binance Smart Chain BEP-20 </b>
          {t('payment_method.text2')} <b>{t('payment_method.text3')}</b>{' '}
          {t('payment_method.text4')}
        </div>
      );

    // case NetworkType.TRC_20:
    //   return (
    //     <div>
    //       <b>{t('payment_method.important')}:</b> <br />
    //       {t('payment_method.text1')}
    //       <b> Tron Network TRC-20 </b>
    //       {t('payment_method.text2')} <b>{t('payment_method.text3')}</b>
    //       {t('payment_method.text4')}
    //     </div>
    //   );

    case NetworkType.ULTRON:
      return (
        <div>
          <b>{t('payment_method.important')}:</b> <br />
          {t('payment_method.text1')}
          <b> Ultron Chain (ULC-20) </b>
          {t('payment_method.text2')} <b>{t('payment_method.text3')}</b>
          {t('payment_method.text4')}
        </div>
      );
    default:
      return null;
  }
};
